/**
 * 부팅 단계별 시간 — 게임(main.ts)이 로딩을 끝낼 때 콘솔에 `[boot]` 로 찍고 `__cs.boot` 에 둔다.
 * 에디터(place-main.ts)의 bootLog 와 같은 쓰임. 첫 로딩을 줄일 때 어디서 시간이 드는지 여기서 본다
 */
const log: [string, number][] = [];

/** 이 단계가 **끝난** 시각을 적는다 */
export function bootMark(label: string) {
  log.push([label, Math.round(performance.now())]);
}

/** 단계별 소요(ms) — 앞 표시부터 이 표시까지 */
export function bootReport(): Record<string, number> {
  const out: Record<string, number> = {};
  for (let i = 1; i < log.length; i++) out[log[i][0]] = log[i][1] - log[i - 1][1];
  return out;
}
